import React from "react";
import { useDrag } from "react-dnd";
import "./ElementLibrary.css";

export const ElementLibrary = () => {

  return (
    <div className="elib-root">
      {library.map(category => <Category category={category} />)}
    </div>
  )
}


const Category = ({category}) => {

  return (
    <div className="elib-category">
      <span className="elib-category-label">{category.name}</span>
      {category.items.map(item => item.value ? <ElementBlock item={item} /> : <Title caption={item.name} />)}
    </div>
  )


}

const Title = ({caption}) => {
  return (
    <span className="elib-title">{caption}</span>
  );
}

const ElementBlock = ({item}) => {

  const [{isDragging}, drag] = useDrag(() => ({
    type: 'HTML_BLOCK_ELEMENT' ,
    item: item.value,
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  }), [item.value])

  return (
    <div ref={drag} className="elib-element-block">
      {item.name}
    </div>
  );

}


const library = [
  {
    name: "Nativos",
    items: [
      {name: "Texto" },
      {name: "text", value: { "node": "text", "text": "" } },
      {name: "span", value: { "node": "element", "tag": "span", "child": [] } },
      {name: "h1", value: { "node": "element", "tag": "h1", "child": [] } },
      {name: "h2", value: { "node": "element", "tag": "h2", "child": [] } },
      {name: "h3", value: { "node": "element", "tag": "h3", "child": [] } },
      {name: "h4", value: { "node": "element", "tag": "h4", "child": [] } },
      {name: "h5", value: { "node": "element", "tag": "h5", "child": [] } },
      {name: "h6", value: { "node": "element", "tag": "h6", "child": [] } },
      {name: "Contenedor" },
      {name: "div", value: { "node": "element", "tag": "div", "child": [] } },
      {name: "Tabla" },
      {name: "table", value: { "node": "element", "tag": "table", "child": [] } },
      {name: "tr", value: { "node": "element", "tag": "tr", "child": [] } },
      {name: "th", value: { "node": "element", "tag": "th", "child": [] } },
      {name: "td", value: { "node": "element", "tag": "td", "child": [] } },
      {name: "img", value: { "node": "element", "tag": "img", "child": [] } },
      {name: "Acción" },
      {name: "a", value: { "node": "element", "tag": "a", "child": [] } },
      {name: "button", value: { "node": "element", "tag": "button", "child": [] } },
      {name: "Campo" },
      {name: "input", value: { "node": "element", "tag": "input", "child": [] } },
      {name: "textarea", value: { "node": "element", "tag": "textarea", "child": [] } },
    ]
  },
  {
    name: "Orquesta",
    items: [
      {name: "Datos" },
      {name: "form_ext", value: { "node": "element", "tag": "form_ext", "child": [] } },
    ]
  }
]
